import { CreateSubtenantBody, UpdateSubtenantBody } from '@bioliberty/lifemind';
import { HttpMethod } from '../util/http';
import { tms } from './tms';

type UpdateSubtenantParams = UpdateSubtenantBody & {
  name: string;
};

const subtenantsApi = tms.injectEndpoints({
  endpoints: (builder) => ({
    createSubtenant: builder.mutation<void, CreateSubtenantBody>({
      query: (body) => ({
        url: `subtenants`,
        method: HttpMethod.Post,
        body
      }),
      invalidatesTags: ['Subtenants', 'Profile', 'Users', 'Clinics']
    }),
    updateSubtenant: builder.mutation<void, UpdateSubtenantParams>({
      query: ({ name, label, lifeglovLinerStockLowThreshold, monthlyCapacity, timezone, inactive }) => ({
        url: `subtenants/${name}`,
        method: HttpMethod.Put,
        body: { label, lifeglovLinerStockLowThreshold, monthlyCapacity, timezone, inactive }
      }),
      invalidatesTags: ['Subtenants', 'Profile', 'Clinics']
    })
  })
});

export const { useCreateSubtenantMutation, useUpdateSubtenantMutation } = subtenantsApi;
